import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './layout/header/header.component';
import { ToastContainerComponent } from './shared-components/toast-container/toast-container.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, HeaderComponent, ToastContainerComponent],
    styleUrl: './app.component.scss',
    template: `
    <main class="main">
      <div class="content">
        <app-header></app-header>
        <app-toast-container></app-toast-container>
        <router-outlet />
      </div>
    </main>
`
})
export class AppComponent {
  title = 'QuizTime : Manage your quizzes';
}
